import React from "react";
import MyTasks from "../components/MyTasks";

const MyTasksScreen = (props) => {
  return <MyTasks {...props} />;
};
export default MyTasksScreen;
